import { Filter } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SKILL_LEVELS } from './skill-level-utils';

interface SkillLevelFilterProps {
  value: string;
  onChange: (value: string) => void;
}

export function SkillLevelFilter({ value, onChange }: SkillLevelFilterProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="flex items-center gap-2 shrink-0">
          <Filter className="w-4 h-4" />
          {value ? value.charAt(0).toUpperCase() + value.slice(1) : 'Skill'}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuRadioGroup value={value} onValueChange={onChange}>
          {SKILL_LEVELS.map(level => (
            <DropdownMenuRadioItem key={level.value} value={level.value}>
              {level.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
